'use client';

import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const root = css`
  box-shadow: ${theme.elevation.peoople};
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  display: flex;
  gap: 0.75rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  aspect-ratio: 3/4;
  width: 190px;
  height: 265px;
`;

export const avatar = css`
  min-width: 90px;
`;

export const nickname = css`
  font-size: 1rem;
  font-weight: 600;
  max-width: 100%;
  color: ${theme.colors.neutral[3]};
`;
export const name = css`
  font-size: 1.1rem;
  font-weight: 700;
  color: black;
`;

export const recommendations = css`
  font-size: 0.8em;
  color: ${theme.colors.neutral[3]};
`;

export const info = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 100%;
`;

export const followButton = css`
  font-weight: 600 !important;
  font-size: 0.9rem;
`;
